(function() {
    'use strict';

    angular
        .module('bhsApp')
        .controller('TableauRepartitionAccTrajetSansArretCtrl', TableauRepartitionAccTrajetSansArretCtrl);

    TableauRepartitionAccTrajetSansArretCtrl.$inject = ['$scope', '$state', 'ParseLinks', 'AlertService'];

    function TableauRepartitionAccTrajetSansArretCtrl ($scope, $state, ParseLinks, AlertService) {

    }
})();
